import React from 'react'
import debounce from '../../../../../helpers/debounce.helper'
import { AdminService } from '../../../../../services/admin.service'
import { AsyncSelectInput } from '../../../../../components/form-components/inputs.component'
import { StyledPointsBlock } from '../styles.style'

export const PointsBlock = props => (
	<StyledPointsBlock>
		<AsyncSelectInput
			className="async-select-field"
			label="Nome *"
			loadOptions={(inputValue, callback) => {
				debounce(
					300,
					() => {
						AdminService.searchUsersToMovePoints(
							inputValue || props.initialSearchValue || ''
						).then(({ data }) => {
							const options = data.map(({ moveflexNumber, data }) => ({
								value: moveflexNumber,
								label: data
							}))

							props.addOptions(options)
							callback(data.length ? options : null)
						})
					},
					`async${props.id}`
				)
			}}
			style={{ width: '100%' }}
			{...props}
		/>
		<div className="points">
			<div className="saldo">Saldo de pontos</div>
			<div className="value">
				{Number(props.points).toLocaleString('pt-BR')}
			</div>
		</div>
	</StyledPointsBlock>
)
